/**
 * Static metadata for the SchemaBuilder UI.
 *
 * In a real deployment, TRANSLATIONS and LOOKUPS would be loaded from the API
 * (the same catalogues the runtime renderer uses). Here we generate a
 * representative sample large enough to exercise the virtualised pickers.
 */

export const NODE_TYPES = {
  OBJECT: 'object',
  ARRAY: 'array',
  PRIMITIVE: 'primitive',
};

export const PRIMITIVE_TYPES = ['string', 'number', 'boolean'];

export const WIDGETS = {
  INPUT: 'input',
  SELECT: 'select',
  DYNAMIC_SELECT: 'dynamicSelect',
};

// Synthetic translation catalogue. Real builder would `API.getTranslationKeys()`.
const seedTranslations = [
  'guid-for-search-term',
  'guid-for-status-title',
  'guid-for-draft',
  'guid-for-published',
  'guid-for-region',
  'guid-for-country',
  'guid-for-category',
  'guid-for-pricing-rules',
  'guid-for-currency',
  'guid-for-discount',
  'guid-for-from-date',
  'guid-for-to-date',
  'guid-for-amount-min',
  'guid-for-amount-max',
  'guid-for-channel',
];
export const TRANSLATIONS = Array.from({ length: 2400 }, (_, i) => {
  const seed = seedTranslations[i % seedTranslations.length];
  return {
    id: `${seed}-${String(i).padStart(4, '0')}`,
    label: seed.replace(/^guid-for-/, '').replace(/-/g, ' '),
  };
});

// Synthetic lookup catalogue.
const seedLookups = [
  'RegionsByCountry',
  'ProductCategories',
  'CommercialCampaigns',
  'Branches',
  'Currencies',
  'PaymentMethods',
  'OutcomeReasons',
  'CustomerSegments',
  'Channels',
  'WaveSections',
];
export const LOOKUPS = Array.from({ length: 1200 }, (_, i) => {
  const seed = seedLookups[i % seedLookups.length];
  return {
    id: `${seed}_${String(i).padStart(3, '0')}`,
    label: seed,
  };
});

export const SCHEMA_BUILDER_VERSION = 1;
